/**
 * @generated SignedSource<<f01ba2374ed38ab06295ffb7242c6d5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedCategoryTilesTracking_itemSearch$data = {
  readonly categoryTiles: ReadonlyArray<{
    readonly itemId: string | null;
    readonly rank: number | null;
    readonly trackingCreative: string | null;
  } | null> | null;
  readonly " $fragmentType": "BuySharedCategoryTilesTracking_itemSearch";
};
export type BuySharedCategoryTilesTracking_itemSearch$key = {
  readonly " $data"?: BuySharedCategoryTilesTracking_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedCategoryTilesTracking_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedCategoryTilesTracking_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseCategoryTiles",
      "kind": "LinkedField",
      "name": "categoryTiles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "trackingCreative",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rank",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "23814dad07630ca6691be921d9881291";

export default node;
